import React from 'react';

export default function Spinner() {
  return (
    <div className="flex items-center justify-center h-16 mt-4">
      <div className="loading-spinner"></div>
    </div>
  );
}
